export const SHARED_HOSTING_TYPE = 'shared_hosting'
export const VPS_TYPE = 'vps'
export const GSUITE_TYPE = 'gsuite'
export const EMAIL_HOSTING_TYPE = 'email_hosting'
export const SSL_TYPE = 'ssl'
export const DOMAIN_TYPE = 'domain'